import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
// Sent through our own domain: ad blockers drop requests to posthog.com, which hid a tenth or
// more of the visitors, desktop mostly (2026-10-04). The path is not "/ingest", the one the
// blocklists learn first. It is the API host's nginx that forwards it to PostHog's EU hosts,
// not a Vercel rewrite on www: there it made 62% of the site's Vercel requests and would have
// passed the free plan's 1,000,000 a month, which pauses the whole site (2026-10-06)
export const POSTHOG_PROXY = 'https://api.clip-short.com/relay-e';
const POSTHOG_UI_HOST = 'https://eu.posthog.com';

let initialized = false;
// How analytics started, on every event: 'default' (on without asking, outside
// the EU/EEA, UK and Switzerland) or 'accepted' (the bar). Set before init, so
// the first pageview carries it too; a super property registered after init
// missed it
let consentSource = null;
export function setConsentSource(value) {
  consentSource = value || null;
}

/**
 * The language the app is showing (<html lang>, set from the page's locale),
 * on every event. The browser's language was the only one there was, and it
 * is a guess: whether Spanish speakers reach the editor's Export is a question
 * about the Spanish app, not about Spanish browsers.
 */
export function withAppLocale(event) {
  try {
    const lang = (document.documentElement.lang || '').split('-')[0].toLowerCase();
    if (event?.properties && lang) event.properties.app_locale = lang;
    if (event?.properties && consentSource) event.properties.consent_source = consentSource;
  } catch {
    // Never keep an event from being sent
  }
  return event;
}

export function initPosthog() {
  if (initialized) return;

  // Only enable analytics in production
  if (import.meta.env.MODE !== 'production') {
    return;
  }

  if (!POSTHOG_KEY) {
    console.warn('[analytics] PostHog key missing; analytics disabled.');
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_PROXY,
    ui_host: POSTHOG_UI_HOST,
    capture_pageview: 'history_change',
    capture_pageleave: 'if_capture_pageview',
    persistence: 'localStorage',
    autocapture: true,
    before_send: withAppLocale,
  });

  initialized = true;
}

export default posthog;

